import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { BaseLayoutComponent } from "./Layout/base-layout/base-layout.component";
import { PagesLayoutComponent } from "./Layout/pages-layout/pages-layout.component";

// // Pages

import { ForgotPasswordComponent } from "./pages/UserPages/forgot-password/forgot-password.component";
import { ForgotPasswordBoxedComponent } from "./pages/UserPages/forgot-password-boxed/forgot-password-boxed.component";
import { LoginBoxedComponent } from "./pages/UserPages/login-boxed/login-boxed.component";
import { LoginComponent } from "./pages/UserPages/login/login.component";
import { ConfirmPasswordComponent } from "./pages/UserPages/confirm-password/confirm-password.component";
import { RegisterBoxedComponent } from "./pages/UserPages/register-boxed/register-boxed.component";
import { RegisterComponent } from "./pages/UserPages/register/register.component";
import { AuthGuard } from "./shared/guard/auth.guard";
import { ActivationComponent } from "./pages/UserPages/activation/activation.component";
import { PrivacyPolicyComponent } from "./pages/privacy-policy/privacy-policy.component";
import { TermsConditionComponent } from "./pages/terms-condition/terms-condition.component";
const routes: Routes = [
  {
    path: "",
    component: BaseLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "app",
        loadChildren: () =>
          import("./pages/pages.module").then((m) => m.PagesModule),
      },

      {
        path: "",
        redirectTo: "app/pages",
        pathMatch: "full",
      },
    ],
  },
  {
    path: "",
    component: PagesLayoutComponent,
    children: [
      // User Pages
      {
        path: "pages/privacy-policy",
        component: PrivacyPolicyComponent,
        data: { extraParameter: "" },
      },
      {
        path: "pages/terms-condition",
        component: TermsConditionComponent,
        data: { extraParameter: "" },
      },
      {
        path: "pages/login",
        component: LoginComponent,
        data: { extraParameter: "" },
      },
      {
        path: "pages/login-boxed",
        component: LoginBoxedComponent,
        data: { extraParameter: "" },
      },
      {
        path: "pages/register",
        component: RegisterComponent,
        data: { extraParameter: "" },
      },
      {
        path: "pages/register-boxed",
        component: RegisterBoxedComponent,
        data: { extraParameter: "" },
      },
      {
        path: "pages/forgot-password",
        component: ForgotPasswordComponent,
        data: { extraParameter: "" },
      },
      {
        path: "pages/forgot-password-boxed",
        component: ForgotPasswordBoxedComponent,
        data: { extraParameter: "" },
      },
      {
        path: "pages/resetPassword/:code",
        component: ConfirmPasswordComponent,
        data: { extraParameter: "" },
      },
      {
        path: "pages/activation/:code",
        component: ActivationComponent,
        data: { extraParameter: "" },
      },
    ],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: "enabled",
      anchorScrolling: "enabled",
      relativeLinkResolution: "legacy",
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
